export default "__VITE_ASSET__682db026__"